import { ArrowUpOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import DrawerButton from '../DrawerButton';

const ArrowUpIcon = styled(ArrowUpOutlined)`
  padding-top: 3px;
  font-size: 16px;
`;

function NavigateBackButton() {
  const assetsManager = store.creative?.assets;

  // We can navigate up if this value is truthy:
  // - undefined - no assetsManager present (because no store.creative)
  // - empty string - assetsManager is at the root folder
  const isEnabled = assetsManager?.currentFolder;

  const navigateBack = () => {
    assetsManager?.navigateFolderUp();
  };

  return (
    <DrawerButton disabled={!isEnabled} onClick={navigateBack}>
      <ArrowUpIcon />
    </DrawerButton>
  );
}

export default observer(NavigateBackButton);
